import { useQuery } from "@tanstack/react-query";
import { NavLink } from "react-router-dom";
import { getRequestByAuth } from "../../../../function/helper";
import useSharedData from "../../../../hooks/useSharedData";
import style from "./SidebarItems.module.css";

export const ACCOUNT_WALLET_BALANCE_QUERY_KEY = ["account-wallet-balance"];

function SidebarItems() {
  const { user, isAgent } = useSharedData();

  const { data: currentCredit = 0 } = useQuery({
    queryKey: ACCOUNT_WALLET_BALANCE_QUERY_KEY,
    queryFn: () =>
      getRequestByAuth(`/wallet/v1/all?numberpage=1&numberitems=1`).then(
        datas => {
          if (datas && datas.status === 200) {
            return datas.data.amont ?? 0;
          }
          return 0;
        }
      ),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const { data: everBeenAgent } = useQuery({
    queryKey: ["ever-been-agent"],
    queryFn: () =>
      getRequestByAuth("/agent/v1/is-contract-terminated").then(res => {
        if (res && res.status === 200) {
          return true;
        }

        return false;
      }),

    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retryOnMount: false,
    retryDelay: false,
    refetchInterval: false,
  });

  return (
    <div className={style.siderbarItems}>
      <div className="px-2 my-3">
        <div className="d-flex flex-wrap align-items-center column-gap-2">
          <img
            src="/avatar.png"
            width={50}
            height={50}
            className="bg-avaex-second rounded-circle"
          />
          <p className="flex-grow-1 mb-0">
            <span>{user.name}</span>
            <span> </span>
            <span style={{ overflowWrap: "break-word", inlineSize: "200px" }}>
              {user.family}
            </span>
          </p>
        </div>
        <p className="my-2 d-flex flex-wrap align-items-center">
          <span className="text-primary">موجودی کیف پول: </span>
          <span className="text-success fw-bold fs-4 ltr">
            {currentCredit.toLocaleString()}
          </span>
          <small> &nbsp;ریال</small>
        </p>
      </div>
      <NavLink
        to=""
        className={({ isActive }) => (isActive ? style.active : "")}
        end={true}
      >
        اطلاعات
      </NavLink>

      <NavLink
        to="increase-credit"
        className={({ isActive }) => (isActive ? style.active : "")}
      >
        افزایش اعتبار
      </NavLink>

      <NavLink
        to="address"
        className={({ isActive }) => (isActive ? style.active : "")}
      >
        آدرس های من
      </NavLink>

      {isAgent && (
        <NavLink
          to="insurance"
          className={({ isActive }) => (isActive ? style.active : "")}
        >
          وجه الضمان
        </NavLink>
      )}

      <NavLink
        to="cod-flow"
        className={({ isActive }) =>
          isActive ? style.active + " mb-2" : "mb-2"
        }
      >
        مبالغ بستانکاری COD
      </NavLink>

      <NavLink
        to="wallet-request"
        className={({ isActive }) =>
          isActive ? style.active + " mb-2" : "mb-2"
        }
      >
        درخواست COD/کیف پول
      </NavLink>
      <NavLink
        to="tickets"
        className={({ isActive }) => (isActive ? style.active : "")}
      >
        تیکت ها
      </NavLink>
      <NavLink
        to="discount"
        className={({ isActive }) => (isActive ? style.active : "")}
      >
        کد تخفیف
      </NavLink>
      <NavLink
        to="support"
        className={({ isActive }) => (isActive ? style.active : "")}
      >
        پشتیبانی
      </NavLink>

      {everBeenAgent && (
        <NavLink
          to="termination"
          className={({ isActive }) => (isActive ? style.active : "")}
        >
          اعلامیه فسخ قرارداد
        </NavLink>
      )}

      <NavLink
        to="/logout"
        className={({ isActive }) => (isActive ? style.active : "")}
      >
        خروج
      </NavLink>
    </div>
  );
}

export default SidebarItems;
